import { useMemo, useState } from "react";
import { Card, SectionHeader, TextInput, ConfidenceBar } from "../../components/lib";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { PEOPLE, Person } from "../../mocks/workspaceData";

export default function People() {
  const [tab, setTab] = useState<Person["team"] | "all">("all");
  const [q, setQ] = useState("");
  const filtered = useMemo(() => PEOPLE.filter((p) =>
    (tab === "all" || p.team === tab) &&
    (!q || p.name.toLowerCase().includes(q.toLowerCase()) || p.role.toLowerCase().includes(q.toLowerCase())),
  ), [tab, q]);

  return (
    <div className="space-y-6" data-testid="ws-people">
      <Card testId="ws-p-filters">
        <TextInput value={q} onChange={setQ} placeholder="Search people…" testId="ws-p-search" />
        <div className="mt-4 overflow-x-auto">
          <TabBar<Person["team"] | "all">
            testId="ws-p-tabs"
            active={tab}
            onChange={setTab}
            tabs={[
              { key: "all",       label: "All" },
              { key: "Executive", label: "Executive" },
              { key: "R&D",       label: "R&D" },
              { key: "Ops",       label: "Ops" },
              { key: "Marketing", label: "Marketing" },
              { key: "Digital",   label: "Digital" },
              { key: "Sales",     label: "Sales" },
              { key: "Retail",    label: "Retail" },
              { key: "Finance",   label: "Finance" },
            ]}
          />
        </div>
      </Card>

      <Card padded={false} testId="ws-p-list-card">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Team" title={`${filtered.length} person${filtered.length === 1 ? "" : "s"}`} />
        </div>
        <div className="p-2">
          {filtered.map((p) => (
            <ListRow key={p.id} testId={`ws-per-${p.id}`}
              label={<span>{p.name} · <span className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>{p.role}</span></span>}
              sublabel={<>{p.team} · {p.location} · joined {p.joinedRelative} · {p.status}</>}
              trailing={<div className="w-20"><div className="text-[10px] tabular-nums mb-0.5" style={{ color: "var(--ph-ink-muted)" }}>{Math.round(p.utilisation*100)}%</div><ConfidenceBar value={p.utilisation}/></div>}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
